/**
 * 期間延長 3Dセキュア確定
 */
import Vue from "vue";
import * as httpConst from "../../../../constants/httpConst";

const API_PATH = `${httpConst.FRONTEND_ENDPOINT}/extend_orders`

const extend_confirm = {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    update ({ commit }, { charge_id }) {
      const api_url = `${API_PATH}/${charge_id}/confirms`
      return new Promise((resolve) => {
        Vue.$http.put(api_url).then(data => {
          resolve(data.result)
        })
      })
    },
  },
  mutations: {
  },
}

export default extend_confirm
